import { EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent, CheckTableComponent, ButtonDownloadComponent } from '@app/shared';
import { ButtonDownloadCheckComponent } from '@app/shared/component-table/button-download-check-table.component';
import { data } from 'jquery';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';

export class PublicationsConfigService {
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  vista = true;
  generation: true;

  constructor() {
    const self = this;
    this.settings = {
      selectMode: 'multi',
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay publicaciones para el boletín selecionado',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        tipo_documento: {
          editable: false,
          addable: false,
          title: 'Tipo documento',
          filter: {
            inputClass: 'form-control',
          }
        },
        radicado: {
          editable: false,
          addable: false,
          title: 'Radicado',
          filter: {
            inputClass: 'form-control',
          }
        },
        fecha_radicado: {
          editable: false,
          addable: false,
          title: 'Fecha Radicado',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            const formatted = new DateFormatPipe().transform(row.fecha_radicado);
            return formatted;
          }
        },
        asunto: {
          editable: false,
          addable: false,
          title: 'Asunto',
          filter: {
            inputClass: 'form-control',
          }
        },
        publicado: {
          editable: false,
          addable: false,
          title: 'Publicado',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            },
          },
        },
        fecha_publicacion: {
          editable: false,
          addable: false,
          title: 'Fecha Publicación',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            const formatted = new DateFormatPipe().transform(row.fecha_publicacion);
            return formatted;
          }
        },
        id_documento_historial: {
          editable: false,
          addable: false,
          title: 'Documento',
          type: 'custom',
          renderComponent: ButtonDownloadCheckComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              const sendData = {
                'action': 'descargar',
                'data': data
              };
              self.accion.emit(sendData);
            });
          },
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            }
          },
        },
        id: {
          title: 'Acciones',
          filter: false,
          sort: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: ButtonsActionsTableComponent) {
            instance.hiddenDelete = true;
            instance.save.subscribe((data: any) => {
              // Controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/publications/shared/publications.config.service.ts